import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Generated class for the MmseToolComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "mmse-tool",
  templateUrl: "mmse-tool.html",
})
export class MmseToolComponent {
  @Input() readonly: boolean = false;
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();

  values = {};
  totalScore = 0;
  orientationScore;
  registrationScore;
  attentionCalculationScore;
  recallScore;
  languageScore;

  constructor() {}

  @Input() set existingData(data: object) {
    // console.log( "Tool received existing data: ", data );
    if (data !== undefined && data != null) {
      this.values = data["values"];
    }
    this.calculateScores();
  }

  valueChanged(question: string, value: number) {
    if (!this.readonly) {
      this.values[question] = value;
      this.calculateScores();
      this.onValueUpdate.emit({
        values: this.values,
        score: this.totalScore,
      });
    }
  }

  calculateScores() {
    let values = this.values;
    let total = 0;

    let oScore = 0;
    if (values["mmseCurrentDate"] != undefined) {
      oScore += values["mmseCurrentDate"] * 1;
    }
    if (values["mmseCurrentPlace"] !== undefined) {
      oScore += values["mmseCurrentPlace"] * 1;
    }
    this.orientationScore = oScore;
    total += oScore;

    if (values["nameThreeObjects"] != undefined) {
      this.registrationScore = values["nameThreeObjects"] * 1;
      total += this.registrationScore * 1;
    }

    if (values["worldBackwards"] != undefined) {
      this.attentionCalculationScore = values["worldBackwards"] * 1;
      total += this.attentionCalculationScore * 1;
    }

    if (values["threePreviousObjects"] != undefined) {
      this.recallScore = values["threePreviousObjects"] * 1;
      total += this.recallScore * 1;
    }

    let lScore = 0;
    if (values["namePencilWatch"] != undefined) {
      lScore += values["namePencilWatch"] * 1;
    }
    if (values["noIfsAndsOrButs"] !== undefined) {
      lScore += values["noIfsAndsOrButs"] * 1;
    }
    if (values["threeStageCommand"] !== undefined) {
      lScore += values["threeStageCommand"] * 1;
    }
    if (values["closeYourEyes"] !== undefined) {
      lScore += values["closeYourEyes"] * 1;
    }
    if (values["writeASentence"] !== undefined) {
      lScore += values["writeASentence"] * 1;
    }
    if (values["copyDesign"] !== undefined) {
      lScore += values["copyDesign"] * 1;
    }
    this.languageScore = lScore;
    total += lScore;

    this.totalScore = total;
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/mmse-tool/mmse-tool.ts